import React from "react";

const Gradient3 = ({ className }) => {
  return (
    <svg
      width="352"
      height="440"
      viewBox="0 0 352 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <g filter="url(#filter0_f_3345_4240)">
        <circle cx="220" cy="220" r="100" fill="#000BE3" fill-opacity="0.32" />
      </g>
      <defs>
        <filter
          id="filter0_f_3345_4240"
          x="0"
          y="0"
          width="440"
          height="440"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="60"
            result="effect1_foregroundBlur_3345_4240"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Gradient3;
